import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /subsidiary-preferences is a container — redirect to the default child
 * (Customer Constraints) so the URL is always explicit about which page is active.
 */
export const Route = createFileRoute('/_authenticated/_tenant/subsidiary-preferences/')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/subsidiary-preferences/constraints', search });
  },
});
